import React, { useState } from 'react';
import { Navigate, Outlet } from "react-router-dom";
import { UTIL_METHODS } from '../../utils';

export default function PrivateRoute() {
    const token = UTIL_METHODS.getToken();
    const [authToken, setAuthToken] = useState(true);
    return <>{token ? <Outlet /> : <Navigate to="/" />}</>;
}
